module.exports = __webpack_public_path__ + "static/media/78_dzz3.9b64fd0d.jpg";